module.exports = __webpack_public_path__ + "static/inna-valouskova-5738ebebe38fc747e17793cbcaa648bd.jpg";